/** Validates that the given attribute values are UUID strings. */
export default function validateUUID(attributes) {
  for (const attributeName in attributes) {
    const value = attributes[attributeName]

    if (typeof value != "string") {
      throw new Error(`Expected '${attributeName}' to be a UUID string, but got: ${typeof value}`)
    }

    if (!value.match(/^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i)) {
      throw new Error(`Expected '${attributeName}' to be a UUID, but got: ${value}`)
    }
  }

  return attributes
}
